import React from "react";
import {
  Box,
  Button,
  Card,
  Divider,
  FormHelperText,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  CategoryProductDialog,
  CustomeDialog,
  useAppConfig,
} from "../../../shared";

export const BXGYRuleCard = (props) => {
  const {
    state,
    globalData,
    handleProductModal,
    handleProductSelect,
    handleAddProductToBXGY,
    handleProductSearch,
    handleBxGyInput,
    validator,
    handleProductRemove,
  } = props;
  const { currencySymbol } = useAppConfig();
  const {
    productModal,
    filteredModalProductList,
    productModalType,
    selectedProducts,
  } = state;
  const { scope, rules } = state.data;

  const targetProduct =
    rules.find((rule) => rule.rule_type === "target_product")?.value || [];
  const qualifyProduct =
    rules.find((rule) => rule.rule_type === "qualify_product")?.value || [];

  return (
    <>
      <Card sx={{ mb: "24px" }}>
        {scope === 5 && (
          <Stack
            sx={{
              p: "20px",
              flexDirection: "row",
              gap: "20px",
            }}
          >
            <InputControl
              name="qualify_product_qty"
              label="Qualifying Product Qty"
              sx={{ width: "100%", bgcolor: "#fff" }}
              isDisabledKeys={["."]}
              type="number"
              value={
                rules.find((r) => r.rule_type === "qualify_product_qty")
                  ?.value || ""
              }
              onChange={(e) =>
                handleBxGyInput("qualify_product_qty", e.target.value)
              }
              error={validator.current.message(
                "Qualifying Product Qty",
                rules.find((r) => r.rule_type === "qualify_product_qty")?.value,
                "required"
              )}
              helperText={validator.current.message(
                "Qualifying Product Qty",
                rules.find((r) => r.rule_type === "qualify_product_qty")?.value,
                "required"
              )}
            />
            <InputControl
              name="target_product_qty"
              label="Target Product Qty"
              type="number"
              isDisabledKeys={["."]}
              sx={{ width: "100%", bgcolor: "#fff" }}
              value={
                rules.find((r) => r.rule_type === "target_product_qty")
                  ?.value || ""
              }
              onChange={(e) =>
                handleBxGyInput("target_product_qty", e.target.value)
              }
              error={validator.current.message(
                "Target Product Qty",
                rules.find((r) => r.rule_type === "target_product_qty")?.value,
                "required"
              )}
              helperText={validator.current.message(
                "Target Product Qty",
                rules.find((r) => r.rule_type === "target_product_qty")?.value,
                "required"
              )}
            />
            <InputControl
              type="select"
              name="action_type"
              label="Action Type"
              sx={{ width: "100%", bgcolor: "#fff" }}
              value={
                rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.rule_type || ""
              }
              optionValue={globalData.discount_mode ?? []}
              onChange={(e) => handleBxGyInput("action_type", e.target.value)}
            />
            <InputControl
              name="action_value"
              label={`Value per product${
                rules.find((r) => r.rule_type === "percentage")
                  ? " (%)"
                  : ` (${currencySymbol})`
              }`}
              sx={{ width: "100%", bgcolor: "#fff" }}
              value={
                rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.value || ""
              }
              onChange={(e) => {
                const value = e.target.value;
                const ruleType = rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.rule_type;
                handleBxGyInput(ruleType, value);
              }}
              type="number"
              inputProps={{
                min: 0,
                max: rules.find((r) => r.rule_type === "percentage")
                  ? 100
                  : undefined,
                step: "0.01",
              }}
              disabled={
                !rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.rule_type
              }
              error={validator.current.message(
                "Value per product",
                rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.value,
                rules.find((r) => r.rule_type === "percentage")
                  ? "required|numeric|min:0,num|max:100,num"
                  : "required|numeric|min:0,num"
              )}
              helperText={validator.current.message(
                "Value per product",
                rules.find(
                  (r) => r.rule_type === "percentage" || r.rule_type === "fixed"
                )?.value,
                rules.find((r) => r.rule_type === "percentage")
                  ? "required|numeric|min:0,num|max:100,num"
                  : "required|numeric|min:0,num"
              )}
            />
          </Stack>
        )}
        <Stack direction="row">
          <Box width="100%" bgcolor="#F7F7F7">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="48px"
              p="4px 16px 4px 8px"
              bgcolor="#0000000F"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Qualifying Products ({qualifyProduct.length})
              </Typography>
              <Button
                type="button"
                size="small"
                variant="text"
                color="info"
                onClick={() => handleProductModal(true, "qualify_product")}
              >
                Modify Product
              </Button>
            </Stack>
            <Divider />
            <Stack
              sx={{
                flexDirection: "row",
                // gap: "20px",
              }}
            >
              <List sx={{ width: "100%", bgcolor: "background.paper", p: 0 }}>
                {qualifyProduct.map((data, index) => (
                  <>
                    <ListItemButton
                      key={index}
                      sx={{
                        borderBottom: "1px solid #E6E6E6",
                        cursor: "inherit",
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="subtitle2"
                            color="#171717"
                          >
                            {data.label}
                          </Typography>
                        }
                      />
                      <CancelIcon
                        sx={{
                          color: "#666",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleProductRemove("qualify_product", data.value)
                        }
                      />
                    </ListItemButton>
                  </>
                ))}
                <FormHelperText sx={{ color: "#C60808", p: "4px" }}>
                  {validator.current.message(
                    "qualifyProduct",
                    qualifyProduct,
                    "required|min:1",
                    {
                      messages: {
                        min: "At least one qualifying product is required.",
                      },
                    }
                  )}
                </FormHelperText>
              </List>
            </Stack>
          </Box>
          <Box width="100%" borderLeft="1px solid #E6E6E6" bgcolor="#F7F7F7">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="48px"
              p="4px 16px 4px 8px"
              bgcolor="#0000000F"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Targeted Product ({targetProduct.length})
              </Typography>
              <Button
                type="button"
                size="small"
                variant="text"
                color="info"
                onClick={() => handleProductModal(true, "target_product")}
              >
                Modify Product
              </Button>
            </Stack>
            <Divider />
            <Stack
              sx={{
                flexDirection: "row",
                // gap: "20px",
              }}
            >
              <List sx={{ width: "100%", bgcolor: "background.paper", p: 0 }}>
                {targetProduct.map((data, index) => (
                  <>
                    <ListItemButton
                      key={index}
                      sx={{
                        borderBottom: "1px solid #E6E6E6",
                        cursor: "inherit",
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="subtitle2"
                          >
                            {data.label}
                          </Typography>
                        }
                      />
                      <CancelIcon
                        sx={{
                          color: "#666",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleProductRemove("target_product", data.value)
                        }
                      />
                    </ListItemButton>
                  </>
                ))}
                <FormHelperText sx={{ color: "#C60808", p: "4px" }}>
                  {validator.current.message(
                    "targetProduct",
                    targetProduct,
                    "required|min:1",
                    {
                      messages: {
                        min: "At least one targeted product is required.",
                      },
                    }
                  )}
                </FormHelperText>
              </List>
            </Stack>
          </Box>
        </Stack>
      </Card>
      <CustomeDialog
        open={productModal}
        handleClose={() => handleProductModal(false)}
        PaperProps={{
          sx: { width: "423px", height: "535px", p: "16px" },
        }}
        title="Products"
        content={
          <CategoryProductDialog
            Items={filteredModalProductList}
            onSelect={handleProductSelect}
            selectedItems={selectedProducts}
            onSubmit={handleAddProductToBXGY}
            existedProductList={[]}
            onSearch={handleProductSearch}
            buttonText="Add"
          />
        }
      />
    </>
  );
};
